module.exports = __webpack_public_path__ + "images/videoCaseStudy-icon-rocket.svg?h=43e80a22c8b688e763c3830a497d6146";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-icon-rocket.svg
// module id = 1479
// module chunks = 12 15